'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Link } from "@argo/ui-elements";
import { colors, size, typography, breakpoints } from "@argo/principles";
import { rgba } from "@argo/utils";
import { navbp } from '../utils/constants';
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
const {
  primary,
  blue
} = colors;
const Menu = styled('ul')`
  ${typography.types.body}
  background-color: ${blue.mutedBlue};
  color: ${primary.white};
  list-style: none;
  margin: 0 0 ${size.md}px ${size.sm}px;
  border-left: 1px solid ${rgba(primary.white, .25)};
  padding: 0;

  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  a {
    display: block;
    padding: ${size.xs}px ${size.sm}px;
    line-height: ${size.sm}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: ${size.md}px;

    a {
      padding: ${size.xs}px ${size.md}px;
    }
  }

  @media (min-width: ${navbp.extraWideViewport}) {
    columns: ${props => Math.ceil(props.children.length / 6)};
    column-gap: 0;
    column-rule: 1px solid ${rgba(colors.primary.white, .25)};
    white-space: nowrap;
    list-style: none;
    margin: 0;
    border: 0;
    padding: ${size.sm}px 0;

    li {
      break-inside: avoid;
    }

    a {
      padding: ${size.xs}px 36px;
      line-height: ${size.lg}px;
    }
  }
`;
export default ({
  tags,
  triggerAnalytics,
  menuItems,
  ...rest
}) => React.createElement(Menu, rest, menuItems.map((menuLink, i) => {
  return React.createElement("li", {
    key: i
  }, React.createElement(Link, {
    onClick: triggerAnalytics && triggerAnalytics({
      googleTag: menuLink.googleTag,
      pixallTag: menuLink.pixallTag
    }),
    "data-automation": menuLink.omnitureTag,
    "data-partner": menuLink.partnerLink,
    "data-tag-id": `NavDropdown${i}`,
    type: 'unstyled',
    href: `${GLOBALNAV_KBB_BASE_URL}${menuLink.url}`
  }, menuLink.name));
}));